export default __webpack_public_path__ + "static/media/left.2cdbb41d.svg";